import React from "react";
import { useTranslation } from "react-i18next";
import { useDeleteConversation } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ChatConversationRemoval({ conversation, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, deleteConversation } = useDeleteConversation();

  return (
    <Modal
      header={t("chatConversationRemoval.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <p className={styles.message}>
          {t("chatConversationRemoval.message")}{" "}
          <span className={styles.name}>
            {conversation.title || t("chatbot.sidebar.untitled")}
          </span>
        </p>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("chatConversationRemoval.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() =>
              deleteConversation({ conversationId: conversation.uuid })
            }
          >
            {t("chatConversationRemoval.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ChatConversationRemoval };
